import { Divider, Modal } from 'antd';
import { useMemo } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from '../../InventoryStore';
import { useFilteredExperiences } from '../../_components/TabViews/ExperiencesTab/hooks/useFilteredExperiences';

import styles from './TimeslotsModal.module.scss';
import { Calendar } from './_components/Calendar/Calendar';
import { Header } from './_components/Header/Header';

export const TimeslotsModal = () => {
  const { sortedExperiences, sortedExperiencesIsAlwaysIncludedWithNight } =
    useFilteredExperiences();

  const activities = useMemo(
    () => [...sortedExperiences, ...sortedExperiencesIsAlwaysIncludedWithNight],
    [sortedExperiences, sortedExperiencesIsAlwaysIncludedWithNight]
  );

  const { isOpen, setTimeslotsModal } = useStore(
    inventoryStore,
    useShallow((state) => ({
      isOpen: state.timeslotsModal.isOpen,
      setTimeslotsModal: state.setTimeslotsModal,
    }))
  );

  const handleClose = () => setTimeslotsModal(undefined, false);

  return (
    <Modal
      className={styles.timeslotsModal}
      wrapClassName={styles.timeslotsModalWrapper}
      width={'100%'}
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      closable={false}
      centered
      destroyOnClose
    >
      <Header onClose={handleClose} activities={activities} />
      <Divider className={styles.headerDivider} />
      <Calendar activities={activities} />
    </Modal>
  );
};
